module.exports = __webpack_public_path__ + "static/media/LowSetupCost.fac7082a.svg";